import { Model, fields } from '@gasman/smush';

class Sample extends Model([
    new fields.IntegerField('repeat', { min: 0, max: 32, default: 0 }),
    new fields.IntegerField('repeatLength', {
        min: 1,
        max: 32,
        default: 1,
        label: 'Replen',
    }),
    new fields.ListField(
        'volumes',
        new fields.IntegerField('volume', { min: 0, max: 15, default: 0 }),
        { length: 32 },
    ),
    new fields.ListField(
        'noiseLevels',
        new fields.IntegerField('noiseLevel', { min: 0, max: 31, default: 0 }),
        { length: 32 },
    ),
    new fields.ListField(
        'toneMasks',
        new fields.BooleanField('toneMask', { default: false }),
        { length: 32 },
    ),
    new fields.ListField(
        'noiseMasks',
        new fields.BooleanField('noiseMask', { default: true }),
        { length: 32 },
    ),
    new fields.ListField(
        'tones',
        new fields.IntegerField('tone', { min: -4095, max: 4095, default: 0 }),
        { length: 32 },
    ),
]) {}

export { Sample };
